import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { TitlePage } from '../../TitlePage/TitlePage';
import { TextPage } from '../../TextPage/TextPage';
import done from './img/done-green.svg'
import './Mail.scss'

const Mail = ({ title, text, setIsModal }) => {

    return (
        <div className='blackout'>
            <div className='modal-mail'>
                <img className='modal-mail__img' src={done} />
                {title && <TitlePage
                    title={title}
                    medium
                />}
                {text && <TextPage
                    text={text}
                    style={{
                        textAlign: 'center'
                    }}
                />}
                <ButtonBasic
                    text='ok'
                    blue
                    width='120px'
                    minWidth='120px'
                    onClick={(e) => setIsModal(false)}
                />
            </div>
        </div>
    )
}

export { Mail }